import { Component, OnInit, OnChanges, SimpleChanges, ViewChild, OnDestroy, AfterViewInit } from '@angular/core';
import { DashboardService } from '../../../../../service/events/dashboard.service';
import { FormCommonApiService } from '../../../../../service/api/formcommon-api.service';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseForm } from '../../../../base-form';
import { build, pool } from '../../../../../common/classes/request-builder';
import moment from 'moment';
import html2canvas from 'html2canvas';
import { RequestButtonComponent } from 'src/app/common/components/request-button/request-button.component';
import { TratamientosApiService } from 'src/app/service/api/tratamientos-api.service';
import { FincasApiService } from 'src/app/service/api/fincas-api.service';
import { environment } from 'src/environments/environment';
import { ProductosApiService } from 'src/app/service/api/productos-api';
import { TareasApiService } from 'src/app/service/api/tareas-api.service';
import { TrabajadoresApiService } from 'src/app/service/api/trabajadores-api.service';
import { Utils } from '../../../../../common/utils';
import { jsPDF } from 'jspdf';
import { TratamientosControlModel } from 'src/app/models/tratamientos/tratamientos-control.model';
import { TareasBioModel } from 'src/app/models/tareas/tareas-bio.model';
import { Uso } from 'src/app/models/productos/uso.model';
import { ProductosModel } from 'src/app/models/productos/productos.model';
import { ReactiveFormBuilderComponent } from 'src/app/common/components/reactive-form-builder/form-builder.component';
import { ReplaySubject, Subject } from 'rxjs';
import { TratamientosControlFormDefinition } from './form-definition';
import { FilteredValue } from 'src/app/common/components/reactive-form-builder/interfaces/input.interface';
import { FormType } from 'src/app/common/components/reactive-form-builder/interfaces/form.interface';

moment.locale('es');

@Component({
    selector: 'app-control-tratamientos-form',
    standalone: false,
    templateUrl: './control-form.component.html',
    styleUrls: ['./control-form.component.scss']
})
export class TratamientosControlFormComponent extends BaseForm<TratamientosControlModel> implements OnInit, OnChanges, OnDestroy, AfterViewInit {

    private static readonly DEFAULT_REAL_UNIT = 'cc/100 L';
    private static readonly CONTROL_SLOTS = [1, 2, 3] as const;

    @ViewChild(RequestButtonComponent, { read: RequestButtonComponent, static: true })
        requestButton = new RequestButtonComponent<TratamientosControlModel>();

    @ViewChild(ReactiveFormBuilderComponent)
        formBuilder!: ReactiveFormBuilderComponent<TratamientosControlModel>;

    public appName = environment.appName;

    public override dropdownsFinalized = false;
    public override readonly dropdownLoadTrigger = new ReplaySubject<void>(1);

    public showEliminarControl = false;
    public formType = this.getType();

    public override pathToGoBack = 'tratamientos-control';
    public override model: TratamientosControlModel = { estado: 'Planificado' };

    public form!: TratamientosControlFormDefinition;

    public receta: TratamientosControlModel = {};
    public showReceta = false;
    public isGeneratingCanvas = false;

    private static readonly CAMPOS_TEMPORALES = [
        '_linea_producto', '_linea_uso', '_linea_plaga',
        '_linea_dosis_cuaderno', '_linea_ud_cuaderno',
        '_linea_dosis', '_linea_ud_real', 'lineas_materias'
    ];

    private _applyingEditState = false;
    private _applyingAutoUnitPatch = false;

    public get requestActivo() {
        const base = this.formType === FormType.EDITION
            ? this.tratamientosApi.tratamientosControl.PUT
            : this.tratamientosApi.tratamientosControl.POST;

        return new Proxy(base, {
            get: (target, prop) => {
                if (prop === 'perform' || prop === 'safePerform') {
                    return (body: Record<string, unknown>, ...args: unknown[]) => {
                        const clean = { ...body };

                        console.log('[PUT body]',
                            '_linea_plaga:', clean['_linea_plaga'],
                            'plaga1:', clean['plaga1'],
                            'plaga2:', clean['plaga2'],
                            'plaga3:', clean['plaga3']
                        );

                        const split = (key: string): string[] => {
                            const raw = String(clean[key] ?? '');
                            return raw ? raw.split(';') : [];
                        };

                        const productos     = split('_linea_producto');
                        const usos          = split('_linea_uso');
                        const plagas        = split('_linea_plaga');
                        const dosisCuaderno = split('_linea_dosis_cuaderno');
                        const udCuaderno    = split('_linea_ud_cuaderno');
                        const dosis         = split('_linea_dosis');
                        const udReal        = split('_linea_ud_real');

                        for (const n of [1, 2, 3] as const) {
                            const i = n - 1;
                            clean[`id_producto${n}`]    = productos[i]      || null;
                            clean[`uso${n}`]            = usos[i]           ?? '';
                            clean[`plaga${n}`]          = plagas[i]         ?? '';
                            clean[`dosis_cuaderno${n}`] = dosisCuaderno[i]  ?? '';
                            clean[`ud_cuaderno_${n}`]   = udCuaderno[i]     ?? '';
                            clean[`dosis${n}`]          = dosis[i]          ?? '';
                            clean[`ud_real_${n}`]       = udReal[i]         ?? '';
                        }

                        for (const key of TratamientosControlFormComponent.CAMPOS_TEMPORALES) {
                            delete clean[key];
                        }

                        return (target as any)[prop](clean, ...args);
                    };
                }
                return (target as any)[prop];
            }
        });
    }

    private _dropdownsReady = false;
    private _getReady = false;
    private _editStateApplied = false;

    constructor(
        public override route: ActivatedRoute,
        public override router: Router,
        public fincasApi: FincasApiService,
        public productosApi: ProductosApiService,
        public trabajadoresApi: TrabajadoresApiService,
        public tratamientosApi: TratamientosApiService,
        public tareasApi: TareasApiService,
        public formApi: FormCommonApiService,
        public override dashboard: DashboardService
    ) {
        super(
            route,
            router,
            dashboard,
            tratamientosApi.tratamientosControl.PUT,
            tratamientosApi.tratamientosControl.POST,
            'tratamientos-control',
            'Editar Control de Tratamientos',
            'Crear Control de Tratamientos'
        );

        this.form = new TratamientosControlFormDefinition(this.getType());

        this.route.queryParams.subscribe(params => {
            if (params['finca']) {
                this.model.id_finca = +params['finca'];
            }
            if (params['fecha']) {
                this.model.fecha = moment(params['fecha'], 'DD-MM-YYYY').format('YYYY-MM-DD');
            }
        });
    }

    ngOnChanges(_changes: SimpleChanges): void {
        throw new Error('Method not implemented.');
    }

    ngAfterViewInit(): void {
        setTimeout(() => {
            const formGroupModel = this.formBuilder?.model;
            if (!formGroupModel) { return; }

            const ctrl = formGroupModel.get('_linea_producto');
            const ctrlUso = formGroupModel.get('_linea_uso');
            if (!ctrl) { return; }

            let lastValue = '';
            let lastUsoValue = String(ctrlUso?.value ?? '');
            let initSkipped = false;

            const intervalId = setInterval(() => {
            const current = String(ctrl.value ?? '').trim();

            if (ctrlUso) {
                const currentUso = String(ctrlUso.value ?? '').trim();
                if (currentUso !== lastUsoValue) {
                    lastUsoValue = currentUso;
                    setTimeout(() => {
                        const currentProd = String(ctrl.value ?? '');
                        if (currentProd) {
                            ctrl.patchValue(currentProd, { emitEvent: true });
                        }
                    }, 100);
                }
            }

            if (current !== lastValue) {
                lastValue = current;

                if (!initSkipped) {
                    initSkipped = true;

                    if (this.getType() !== FormType.CREATION || current === '') {
                        const productos = current ? current.split(';').filter((s: string) => s.trim() !== '') : [];
                        for (const n of [1, 2, 3] as const) {
                            const id = productos[n - 1] ?? '';
                            if (id) { this._prevProductoIds[n] = id; }
                        }
                        return;
                    }
                }

                const productos = current ? current.split(';').filter((s: string) => s.trim() !== '') : [];
                for (const n of [1, 2, 3] as const) {
                    const id = productos[n - 1] ?? '';
                    if (id && id !== this._prevProductoIds[n]) {
                        this._prevProductoIds[n] = id;
                        const expectedId = id;
                        this.loadMagramaForProductById(n, id).then(() => {
                            if (this._prevProductoIds[n] !== expectedId) { return; }
                            this.dropdownLoadTrigger.next();
                        });
                    }
                    if (!id && this._prevProductoIds[n]) {
                        this._prevProductoIds[n] = '';
                        this.form.lists[`usos${n}`].filtered = [];
                        this.form.lists[`plagas${n}`].filtered = [];
                    }
                }
            }
        }, 300);

            this.destroy$.subscribe(() => clearInterval(intervalId));
        }, 500);
    }

    ngOnInit(): void {
        this.formType = this.getType();
        this.dropdownsFinalized = false;

        if (this.getType() === FormType.EDITION && !this._getReady) {
            this.tratamientosApi.tratamientosControl.GET.response(() => {
                if (this._getReady) { return; }
                this._getReady = true;
                this.tryApplyEditState();
            });
        }

        this.initFormData();
        this.softInit(this.getType());
    }

    public formChanges(formModel: object, tag: string): void {
        this.model = formModel as TratamientosControlModel;

        if (tag === 'id_maquinaria') {
            localStorage.setItem(
                this.appName + '_CT_MAQUINARIA_SELECTED',
                this.model.id_maquinaria ?? ''
            );
        }

        if (tag === 'id_finca') {
            if (this._editStateApplied) {
                this.model.ids_parcelas = '';
                this.formBuilder?.updateForm({ ids_parcelas: [] }, false);
            }
            const idFinca = typeof this.model.id_finca === 'object'
                ? (this.model.id_finca as any)?.id
                : this.model.id_finca;
            this.form.filterParcelasByFinca(idFinca);
            this.dropdownLoadTrigger.next();
        }

        if (this.isRepeatableLineChange(tag) && !this._applyingEditState && !this._applyingAutoUnitPatch) {
            this.distributeLineasToSlots();
        }

        if (tag === 'estado' && this.appName === 'hernandorena') {
            this.updateHernandorenaRequiredFields();
        }
    }

    public showEliminar(): void {
        this.showEliminarControl = false;
        this.tratamientosApi.tratamientosControl.DELETE.toPromise(this.model)
            .then(() => { window.location.reload(); return; })
            .catch(e => console.log('catch DELETE:', e));
    }

    public generarReceta(): void {
        console.log('[receta] ids_parcelas raw:', this.model.ids_parcelas, 'isArray:', Array.isArray(this.model.ids_parcelas));
        console.log('[receta] receta.ids_parcelas:', this.receta.ids_parcelas);
        console.log('[receta] parcelas.filtered count:', this.form.lists.parcelas.filtered.length);
        console.log('[receta] parcelas.filtered sample IDs:', this.form.lists.parcelas.filtered.slice(0, 3).map((p: any) => p?.value?.id));
        this.receta = Object.create(this.model);

        const idFinca = typeof this.model.id_finca === 'object'
            ? (this.model.id_finca as any)?.id
            : this.model.id_finca;

        if (idFinca) {
            const fincaFound = (this.form.lists.fincas.filtered as any[])
                .find((it: any) => it.value?.id?.toString() === idFinca.toString());
            this.receta.finca_nombre = fincaFound?.value?.nombre
                ?? fincaFound?.label
                ?? '';
        } else {
            this.receta.finca_nombre = '';
        }

        const idsParcelasRaw = this.model.ids_parcelas;
        let idsNormalizados = '';
        if (Array.isArray(idsParcelasRaw)) {
            idsNormalizados = (idsParcelasRaw as any[])
                .map((p: any) => {
                    if (p && typeof p === 'object') { return p.id ?? ''; }
                    return p ?? '';
                })
                .filter((id: any) => id !== '' && id != null)
                .join(';');
        } else if (idsParcelasRaw) {
            idsNormalizados = String(idsParcelasRaw);
        }
        this.receta.ids_parcelas = idsNormalizados;
        console.log('[receta] ids_parcelas normalizados:', idsNormalizados);

        for (const n of [1, 2, 3] as const) {
            const idProducto = (this.model as any)[`id_producto${n}`];
            if (idProducto) {
                const lists = [
                    this.form.lists.productos1,
                    this.form.lists.productos2,
                    this.form.lists.productos3
                ];

                let found: any = null;
                for (const list of lists) {
                    found = (list.filtered as any[])
                        .find((it: any) => it.value?.id?.toString() === idProducto.toString());
                    if (found) { break; }
                }

                if (found) {
                    this.receta[`producto${n}`] = found.value?.producto?.nombre
                        ?? found.value?.nombre
                        ?? '';

                    this.receta[`materia_activa${n}`] = found.value?.producto?.materia_activa
                        ?? found.value?.materia_activa
                        ?? '';
                } else {
                    this.receta[`producto${n}`] = '';
                    this.receta[`materia_activa${n}`] = '';
                }
            } else {
                this.receta[`producto${n}`] = '';
                this.receta[`materia_activa${n}`] = '';
            }

            const dosis = this.receta[`dosis${n}`];
            const ud    = this.receta[`ud_real_${n}`];
            this.receta[`dosis${n}`] = (dosis != null && dosis !== '')
                ? dosis + (ud ? ' ' + ud : '')
                : '';
        }

        this.receta.fecha_dmy = moment(this.model.fecha).format('DD/MM/YYYY');
        this.receta.fecha = moment(this.receta.fecha).format('LL');
        this.showReceta = true;

        const elements = document.getElementsByClassName('p-dialog-content');
        setTimeout(() => { if (elements[0]) { elements[0].scrollTop = 0; } }, 100);
    }

    public imprimirReceta(): void {
        this.isGeneratingCanvas = true;
        html2canvas(
            document.getElementById('html2canvasDiv') ?? new HTMLElement,
            { scale: 2, logging: false }
        ).then(canvas => {
            this.isGeneratingCanvas = false;
            const pdf = new jsPDF('l', 'mm', 'a4');
            const data = canvas.toDataURL('image/png');
            const w = 290;
            pdf.addImage(data, 'png', 0, 0, w, (canvas.height / (canvas.width / w)), 'alias', 'FAST');
            pdf.save((this.receta.plagas || '.').replace('.', ''));
            return;
        }).catch(e => console.log('catch html2canvas:', e));
    }

    public isParcelaSelected(parcela: FilteredValue<any>): boolean {
        const idsRaw = this.receta?.ids_parcelas
            ?? this.model.ids_parcelas
            ?? (this.tratamientosApi.tratamientosControl.GET.value as any)?.[0]?.['ids_parcelas'];

        if (!idsRaw || !parcela?.value?.id) { return false; }

        let ids: string[];
        if (Array.isArray(idsRaw)) {
            ids = (idsRaw as any[])
                .map((p: any) => {
                    if (p && typeof p === 'object') { return String(p.id ?? ''); }
                    return String(p ?? '');
                })
                .filter(s => s !== '');
        } else {
            ids = String(idsRaw).split(/[;,]/).map(s => s.trim()).filter(Boolean);
        }

        return ids.includes(String(parcela.value.id));
    }

    override ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
        this.dropdownLoadTrigger.complete();
        this.tratamientosApi.tratamientosControl.GET.unsuscribe();
        this.tratamientosApi.tratamientosControl.POST.unsuscribe();
        this.tratamientosApi.tratamientosControl.PUT.unsuscribe();
        this.tratamientosApi.tratamientosControl.DELETE.unsuscribe();
    }

    private _prevProductoIds: Record<1 | 2 | 3, string> = { 1: '', 2: '', 3: '' };
    private _prevPlagas: Record<1 | 2 | 3, string> = { 1: '', 2: '', 3: '' };
    private readonly destroy$ = new Subject<void>();

    private distributeLineasToSlots(): void {
        const extract = (field: string): string[] => {
            const raw = String((this.model as any)[field] ?? '');
            return raw ? raw.split(';') : [];
        };

        const productos     = extract('_linea_producto');
        const usos          = extract('_linea_uso');
        const plagas        = extract('_linea_plaga');
        const dosisCuaderno = extract('_linea_dosis_cuaderno');
        const udCuaderno    = extract('_linea_ud_cuaderno');
        const dosis         = extract('_linea_dosis');
        const udReal        = extract('_linea_ud_real');

        const patch: Record<string, string | null> = {};
        const repeatablePatch: Record<string, string> = {};

        for (const n of TratamientosControlFormComponent.CONTROL_SLOTS) {
            const i = n - 1;
            const plaga = plagas[i] ?? '';
            const autoUdCuaderno = this.getUnitForPlaga(n, plaga);
            const plagaChanged = plaga !== this._prevPlagas[n];

            if (autoUdCuaderno && (!udCuaderno[i] || plagaChanged)) {
                udCuaderno[i] = autoUdCuaderno;
            }

            if (plaga && (!udReal[i] || plagaChanged)) {
                udReal[i] = TratamientosControlFormComponent.DEFAULT_REAL_UNIT;
            }

            patch[`id_producto${n}`]    = productos[i]      || null;
            patch[`uso${n}`]            = usos[i]           ?? '';
            patch[`plaga${n}`]          = plaga;
            patch[`dosis_cuaderno${n}`] = dosisCuaderno[i]  ?? '';
            patch[`ud_cuaderno_${n}`]   = udCuaderno[i]     ?? '';
            patch[`dosis${n}`]          = dosis[i]          ?? '';
            patch[`ud_real_${n}`]       = udReal[i]         ?? '';

            this._prevPlagas[n] = plaga;
        }

        repeatablePatch['_linea_ud_cuaderno'] = this.joinRepeatableValues(udCuaderno);
        repeatablePatch['_linea_ud_real'] = this.joinRepeatableValues(udReal);

        Object.assign(this.model, patch, repeatablePatch);
        this.updateReactiveForm({ ...patch, ...repeatablePatch }, this.hasAutomaticUnitChange(repeatablePatch));

        const slotsQueCarganMagrama = TratamientosControlFormComponent.CONTROL_SLOTS.filter(n => {
            const nuevoId = patch[`id_producto${n}`];

            return !!nuevoId && (nuevoId !== this._prevProductoIds[n] || !this.hasMagramaData(n));
        });

        for (const n of TratamientosControlFormComponent.CONTROL_SLOTS) {
            this._prevProductoIds[n] = patch[`id_producto${n}`] ?? '';
        }

        for (const n of TratamientosControlFormComponent.CONTROL_SLOTS) {
            if (!patch[`id_producto${n}`]) {
                this.form.lists[`usos${n}`].filtered = [];
                this.form.lists[`plagas${n}`].filtered = [];
            }
        }

        if (slotsQueCarganMagrama.length === 0) {
            this.dropdownLoadTrigger.next();
            return;
        }

        let pendientes = slotsQueCarganMagrama.length;

        for (const n of slotsQueCarganMagrama) {
            const expectedId = String(patch[`id_producto${n}`]);
            this.loadMagramaForProductById(n, expectedId).then(() => {
                if (this._prevProductoIds[n] !== expectedId) { return; }
                if (patch[`plaga${n}`]) {
                    this.applyUdsFromPlaga(n);
                }
                pendientes--;
                if (pendientes === 0) {
                    this.dropdownLoadTrigger.next();
                }
            });
        }
    }

    private applyEditState(): void {
        if (this.getType() !== FormType.EDITION) { return; }

        const raw = (this.tratamientosApi.tratamientosControl.GET.value as any)?.[0] ?? {};

        const idFinca = raw['id_finca'];
        if (idFinca) {
            this.form.filterParcelasByFinca(idFinca);

            const ctrlFinca = this.formBuilder?.model?.get('id_finca');
            if (ctrlFinca) {
                ctrlFinca.patchValue(idFinca, { emitEvent: false });
            }
            this.model.id_finca = idFinca;
        }

        const idsParcelasRaw = raw['ids_parcelas'];
        if (idsParcelasRaw) {
            const idsArray = String(idsParcelasRaw)
                .split(';')
                .filter(Boolean)
                .map(id => {
                    const n = Number(id);
                    return Number.isFinite(n) ? n : id;
                });

            const ctrl = this.formBuilder?.model?.get('ids_parcelas');
            if (ctrl) {
                ctrl.patchValue(idsArray, { emitEvent: false });
            }
            this.model.ids_parcelas = String(idsParcelasRaw);

            setTimeout(() => {
                const ctrlLate = this.formBuilder?.model?.get('ids_parcelas');
                if (ctrlLate) {
                    const current = ctrlLate.value;
                    const isEmpty = !current || (Array.isArray(current) && current.length === 0);
                    if (isEmpty) {
                        ctrlLate.patchValue(idsArray, { emitEvent: false });
                        this.model.ids_parcelas = String(idsParcelasRaw);
                        this.dropdownLoadTrigger.next();
                    }
                }
            }, 200);
        }

        const fechaRaw = raw['fecha'];
        if (fechaRaw) {
            const ctrl = this.formBuilder?.model?.get('fecha');
            if (ctrl?.pristine) {
                const fechaStr = String(fechaRaw);
                const fechaNormalizada = /^\d{4}-\d{2}-\d{2}$/.test(fechaStr)
                    ? fechaStr
                    : moment(fechaStr, 'DD/MM/YYYY', true).format('YYYY-MM-DD');
                ctrl.patchValue(fechaNormalizada, { emitEvent: false });
            }
        }

        const slotValues = ([1, 2, 3] as const).map(n => ({
            producto: (raw[`id_producto${n}`] && raw[`id_producto${n}`] != '0')
                ? String(raw[`id_producto${n}`])
                : '',
            uso:           String(raw[`uso${n}`]            ?? ''),
            plaga:         String(raw[`plaga${n}`]          ?? ''),
            dosisCuaderno: String(raw[`dosis_cuaderno${n}`] ?? ''),
            udCuaderno:    String(raw[`ud_cuaderno_${n}`]   ?? ''),
            dosis:         String(raw[`dosis${n}`]          ?? ''),
            udReal:        String(raw[`ud_real_${n}`]       ?? ''),
        }));

        for (const n of TratamientosControlFormComponent.CONTROL_SLOTS) {
            this._prevPlagas[n] = slotValues[n - 1]?.plaga ?? '';
        }

        const activeSlots = slotValues.filter(s => s.producto !== '');

        if (activeSlots.length === 0) {
            this.dropdownLoadTrigger.next();
            this._prevProductoIds = { 1: '', 2: '', 3: '' };
            this._prevPlagas = { 1: '', 2: '', 3: '' };
            return;
        }

        const join = (key: keyof typeof activeSlots[0]): string =>
            activeSlots.map(s => s[key]).join(';');

        const repeatablePatch: Record<string, string> = {
            _linea_producto:       join('producto'),
            _linea_uso:            join('uso'),
            _linea_plaga:          join('plaga'),
            _linea_dosis_cuaderno: join('dosisCuaderno'),
            _linea_ud_cuaderno:    join('udCuaderno'),
            _linea_dosis:          join('dosis'),
            _linea_ud_real:        join('udReal'),
        };

        const slotPromises = activeSlots.map((slot, i) => {
            const n = (i + 1) as 1 | 2 | 3;
            const found = (this.form.lists[`productos${n}`].filtered as any[])
                .find((it: any) => it.value?.id?.toString() === slot.producto);
            const referencia = found?.value?.producto?.referencia?.toString();

            if (referencia) {
                return this.getDistinctDataForSlot(n, `'${referencia}'`).then((data) => {
                    if (!data) { return; }
                    this.form.lists[`usos${n}`].filtered   = data.usosFiltered;
                    this.form.lists[`plagas${n}`].filtered  = data.agentesFiltered;
                    (this as any)[`_uds${n}`]   = data.udsFiltered;
                    (this as any)[`_dosis${n}`] = data.dosisFiltered;
                    this.form.refreshDosisSubFieldData(i as 0 | 1 | 2);
                });
            }
            return Promise.resolve();
        });

        Promise.all(slotPromises).then(() => {
            const unitSlotPatch: Record<string, string> = {};

            activeSlots.forEach((slot, index) => {
                const n = (index + 1) as 1 | 2 | 3;
                const autoUdCuaderno = this.getUnitForPlaga(n, slot.plaga);

                if (autoUdCuaderno && !slot.udCuaderno) {
                    slot.udCuaderno = autoUdCuaderno;
                }

                if (slot.plaga && !slot.udReal) {
                    slot.udReal = TratamientosControlFormComponent.DEFAULT_REAL_UNIT;
                }

                unitSlotPatch[`ud_cuaderno_${n}`] = slot.udCuaderno;
                unitSlotPatch[`ud_real_${n}`] = slot.udReal;
            });

            repeatablePatch['_linea_ud_cuaderno'] = join('udCuaderno');
            repeatablePatch['_linea_ud_real'] = join('udReal');

            Object.assign(this.model, unitSlotPatch);
            this.formBuilder?.updateForm(unitSlotPatch, false);

            this.dropdownLoadTrigger.next();
            this._applyingEditState = true;
            this.waitForDropdownsAndPatch(repeatablePatch);
        });
    }

    private loadMagramaForProductById(n: 1 | 2 | 3, id: string): Promise<void> {
        if (!id) { return Promise.resolve(); }

        const searchLists = [
            this.form.lists.productos1,
            this.form.lists.productos2,
            this.form.lists.productos3
        ];

        let referencia: string | undefined;

        for (const list of searchLists) {
            const found = (list.filtered as any[])
                .find((it: any) => it.value?.id?.toString() === id);
            referencia = found?.value?.producto?.referencia?.toString();
            if (referencia) { break; }
        }

        if (!referencia) {
            return Promise.resolve(); 
        }

        const expectedId = id;
        return this.getDistinctDataForSlot(n, `'${referencia}'`).then((data) => {
            if (!data || this._prevProductoIds[n] !== expectedId) {
                return;
            }
            this.form.lists[`usos${n}`].filtered   = data.usosFiltered;
            this.form.lists[`plagas${n}`].filtered  = data.agentesFiltered;
            (this as any)[`_uds${n}`]   = data.udsFiltered;
            (this as any)[`_dosis${n}`] = data.dosisFiltered;
            this.applyUdsFromPlaga(n, true);
        });
    }

    private async getDistinctDataForSlot(
        n: 1 | 2 | 3,
        referencia: string
    ): Promise<{
        usosFiltered: FilteredValue<string>[];
        agentesFiltered: FilteredValue<string>[];
        udsFiltered: { label: string; value: string | null }[];
        dosisFiltered: { label: string; value: string | null }[];
    } | null> {
        try {
            const res: Uso[] = await this.formApi.magramaDetalleProducto.toPromise(
                { referencia } as never
            );

            const usosFiltered: FilteredValue<string>[]    = [];
            const agentesFiltered: FilteredValue<string>[] = [];
            const udsFiltered: { label: string; value: string | null }[]   = [];
            const dosisFiltered: { label: string; value: string | null }[] = [];

            const seenUsos    = new Set<string>();
            const seenAgentes = new Set<string>();

            for (const uso of res) {
                if (uso.uso && !seenUsos.has(uso.uso)) {
                    seenUsos.add(uso.uso);
                    usosFiltered.push({ label: uso.uso, value: uso.uso });
                }
                if (uso.agente && !seenAgentes.has(uso.agente)) {
                    const unidadMedida = uso.unidad_medida || uso.unidades_de_medida || uso.unidad || '';

                    seenAgentes.add(uso.agente);
                    agentesFiltered.push({ label: uso.agente, value: uso.agente });
                    udsFiltered.push({ label: uso.agente, value: unidadMedida || null });
                    dosisFiltered.push({
                        label: uso.agente,
                        value: `Dosis. ${uso.dosis1}-${uso.dosis2} ${unidadMedida} Plazo Seg. ${uso.plazo_seguridad}`
                    });
                }
            }

            return { usosFiltered, agentesFiltered, udsFiltered, dosisFiltered };

        } catch (e) {
            console.warn(`getDistinctDataForSlot(${n}):`, e);
            return null;
        }
    }

    private applyUdsFromPlaga(n: 1 | 2 | 3, force = false): void {
        const selectedPlaga = String((this.model as any)[`plaga${n}`] ?? '').trim();
        if (!selectedPlaga) { return; }

        const udCuaderno = this.getUnitForPlaga(n, selectedPlaga);
        const udReal = TratamientosControlFormComponent.DEFAULT_REAL_UNIT;
        const currentUdCuaderno = String((this.model as any)[`ud_cuaderno_${n}`] ?? '').trim();
        const currentUdReal = String((this.model as any)[`ud_real_${n}`] ?? '').trim();
        const shouldPatchCuaderno = !!udCuaderno && (force || !currentUdCuaderno || selectedPlaga !== this._prevPlagas[n]);
        const shouldPatchReal = force || !currentUdReal || selectedPlaga !== this._prevPlagas[n];

        if (shouldPatchCuaderno) {
            (this.model as any)[`ud_cuaderno_${n}`] = udCuaderno;
        }

        if (shouldPatchReal) {
            (this.model as any)[`ud_real_${n}`] = udReal;
        }

        if (shouldPatchCuaderno || shouldPatchReal) {
            this.patchAutomaticUnitsForSlot(
                n,
                shouldPatchCuaderno ? udCuaderno : currentUdCuaderno,
                shouldPatchReal ? udReal : currentUdReal
            );
        }

        const dosis: { label: string; value: string | null }[] = (this as any)[`_dosis${n}`] ?? [];
        const dosisEntry = dosis.find(e => this.normalizeLookupText(e.label) === this.normalizeLookupText(selectedPlaga));
        if (dosisEntry?.value) {
            (this.model as any)[`recomendacion${n}`] = dosisEntry.value;
        }

        this._prevPlagas[n] = selectedPlaga;
    }


    private isRepeatableLineChange(tag: string): boolean {
        return tag === 'lineas_materias' || tag.startsWith('_linea_');
    }

    private getUnitForPlaga(n: 1 | 2 | 3, selectedPlaga: string): string {
        if (!selectedPlaga) { return ''; }

        const uds: { label: string; value: string | null }[] = (this as any)[`_uds${n}`] ?? [];
        const normalizedPlaga = this.normalizeLookupText(selectedPlaga);
        const udEntry = uds.find(e => this.normalizeLookupText(e.label) === normalizedPlaga);

        return String(udEntry?.value ?? '').trim();
    }

    private hasMagramaData(n: 1 | 2 | 3): boolean {
        const usos = this.form.lists[`usos${n}`].filtered ?? [];
        const plagas = this.form.lists[`plagas${n}`].filtered ?? [];
        const uds = ((this as any)[`_uds${n}`] ?? []) as unknown[];

        return usos.length > 0 || plagas.length > 0 || uds.length > 0;
    }

    private patchAutomaticUnitsForSlot(n: 1 | 2 | 3, udCuaderno: string, udReal: string): void {
        const udCuadernoValues = this.getSerializedValues('_linea_ud_cuaderno');
        const udRealValues = this.getSerializedValues('_linea_ud_real');

        udCuadernoValues[n - 1] = udCuaderno;
        udRealValues[n - 1] = udReal;

        const patch: Record<string, string> = {
            [`ud_cuaderno_${n}`]: udCuaderno,
            [`ud_real_${n}`]: udReal,
            _linea_ud_cuaderno: this.joinRepeatableValues(udCuadernoValues),
            _linea_ud_real: this.joinRepeatableValues(udRealValues)
        };

        Object.assign(this.model, patch);
        this.updateReactiveForm(patch, true);
    }

    private updateReactiveForm(patch: Record<string, string | null>, emitEvent: boolean): void {
        if (!this.formBuilder) { return; }

        if (!emitEvent) {
            this.formBuilder.updateForm(patch, false);
            return;
        }

        this._applyingAutoUnitPatch = true;
        this.formBuilder.updateForm(patch, true);
        setTimeout(() => {
            this._applyingAutoUnitPatch = false;
        }, 0);
    }

    private hasAutomaticUnitChange(repeatablePatch: Record<string, string>): boolean {
        const currentUdCuaderno = String(this.formBuilder?.model?.get('_linea_ud_cuaderno')?.value ?? '');
        const currentUdReal = String(this.formBuilder?.model?.get('_linea_ud_real')?.value ?? '');

        return currentUdCuaderno !== repeatablePatch['_linea_ud_cuaderno']
            || currentUdReal !== repeatablePatch['_linea_ud_real'];
    }

    private getSerializedValues(fieldName: string): string[] {
        const rawValue = this.formBuilder?.model?.get(fieldName)?.value ?? (this.model as any)[fieldName] ?? '';

        return String(rawValue).split(';');
    }

    private getRepeatableRowCount(): number {
        const fields = [
            '_linea_producto', '_linea_uso', '_linea_plaga',
            '_linea_dosis_cuaderno', '_linea_ud_cuaderno',
            '_linea_dosis', '_linea_ud_real'
        ];

        return Math.max(1, ...fields.map(fieldName => this.getSerializedValues(fieldName).length));
    }

    private joinRepeatableValues(values: string[]): string {
        const rowCount = Math.max(values.length, this.getRepeatableRowCount());
        const normalizedValues = Array.from({ length: rowCount }, (_value, index) => values[index] ?? '');

        return normalizedValues.join(';');
    }

    private normalizeLookupText(value: unknown): string {
        return String(value ?? '')
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .trim()
            .replace(/\s+/g, ' ')
            .toLowerCase();
    }

    private updateHernandorenaRequiredFields(): void {
        const isAplicado = this.model.estado === 'Aplicado';
        const requiredWhenAplicado = new Set([
            'ids_parcelas', 'ph_caldo', 'litros', 'ph_agua',
            'ph_final', 'nivel_peligrosidad', 'id_maquinaria', 'estado'
        ]);

        for (const section of this.form.formFields.sections) {
            for (const field of section.fields) {
                if (requiredWhenAplicado.has(field.name as string)) {
                    field.conditions.isRequired = isAplicado;
                }
            }
        }

        this.dropdownLoadTrigger.next();
    }


    private getBioProductValue(product: TareasBioModel['producto']): ProductosModel | null {
        if (typeof product !== 'object' || product === null) {
            return null;
        }

        return product;
    }

    private mapProductos(array: { value: TareasBioModel; label: string; tipo: string }[]) {
        return array
            .map(it => {
                let level = '';
                let numreg = '';
                const product = this.getBioProductValue(it.value?.producto);

                if (product) {
                    level  = Utils.checkIfProductIsValid(product.fecha_caducidad, it.tipo) + ' ';
                    numreg = (product.referencia ?? '') + ' ';
                }
                if (it.label && it.value && it.label.indexOf(it.value.nombre ?? '') === -1) {
                    it.label = level + it.label + ' (' + numreg + it.value.nombre + ')';
                }
                return it;
            })
            .filter(it => it.label);
    }

    private initFormData(): Promise<boolean> {
        const lists = this.form.lists;

        const builds = [
            build(this.fincasApi.fincasGET,           lists.fincas,      'nombre'),
            build(this.fincasApi.parcelasGET,          lists.parcelas,    'nombre'),
            build(this.trabajadoresApi.maquinariaGET,  lists.maquinarias, 'nombre'),
            build(this.productosApi.productos.GET,     lists.productos1,  'materia_activa'),
            build(this.productosApi.productos.GET,     lists.productos2,  'materia_activa'),
            build(this.productosApi.productos.GET,     lists.productos3,  'materia_activa'),
        ];

        const notify = (): void => {
            for (const n of [1, 2, 3] as const) {
                const list = lists[`productos${n}`];
                list.filtered = this.mapProductos(
                    list.filtered as { value: TareasBioModel; label: string; tipo: string }[]
                );
                list.values = [...list.filtered];
            }

            this.form.snapshotAllParcelas();

            if (this.getType() === FormType.CREATION) {
                const saved = localStorage.getItem(this.appName + '_CT_MAQUINARIA_SELECTED');
                if (saved) {
                    this.model.id_maquinaria = saved;
                }
            }

            queueMicrotask(() => {
                this.form.snapshotAllParcelas();
                this.dropdownsFinalized = true;
                this.dropdownLoadTrigger.next();

                this._dropdownsReady = true;
                this.tryApplyEditState();
            });
        };

        return pool(builds, notify);
    }

    private tryApplyEditState(): void {
        if (this._editStateApplied) { return; }
        if (!this._dropdownsReady || !this._getReady) { return; }

        if (this.form.lists.parcelas.filtered.length === 0) {
            setTimeout(() => this.tryApplyEditState(), 100);
            return;
        }

        this._editStateApplied = true;
        this.applyEditState();
    }

    private waitForDropdownsAndPatch(patch: Record<string, string>, attempt = 0): void {
        const maxAttempts = 40;
        const ids = String(patch['_linea_producto'] ?? '').split(';').filter(id => !!id && id !== '0');

        const allResolved = this.form.lists.productos1.filtered.length > 1 &&
            ids.every(id => {
                if (!id || id === '0') { return true; }
                return [
                    this.form.lists.productos1,
                    this.form.lists.productos2,
                    this.form.lists.productos3
                ].some(list =>
                    (list.filtered as any[]).some((it: any) => it.value?.id?.toString() === id)
                );
            });

        if (allResolved || attempt >= maxAttempts) {
            this.formBuilder?.updateForm(patch, true);
            setTimeout(() => {
                this._applyingEditState = false;
            }, 500);
            return;
        }

        setTimeout(() => this.waitForDropdownsAndPatch(patch, attempt + 1), 100);
    }
}